var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_48310",
    "data-name": "Group 48310",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.419,
    height: 27.074,
    viewBox: "0 0 29.419 27.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54321",
    "data-name": "Path 54321",
    d: "M28.13,31.183A11.485,11.485,0,0,0,16.679,20.4H12.74A11.485,11.485,0,0,0,1.289,31.183,2.133,2.133,0,0,0,0,33.14v4.443a2.132,2.132,0,0,0,2.13,2.13H3.854v-8.7H3.03a9.762,9.762,0,0,1,9.71-8.886h3.939a9.762,9.762,0,0,1,9.71,8.886h-.824v8.7h1.724a2.132,2.132,0,0,0,2.13-2.13V33.14A2.133,2.133,0,0,0,28.13,31.183Z",
    transform: "translate(0 -20.4)",
    fill: "#387f75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54322",
    "data-name": "Path 54322",
    d: "M112.974,158.1H99.429a2.362,2.362,0,0,0-2.359,2.359V171.2a2.362,2.362,0,0,0,2.359,2.359h2.954l2.873,3.4a.862.862,0,0,0,1.317,0l2.873-3.4h3.528a2.362,2.362,0,0,0,2.359-2.359V160.459A2.362,2.362,0,0,0,112.974,158.1Zm-3.623,4.316a.862.862,0,1,1-.862.862A.862.862,0,0,1,109.352,162.416Zm-6.665,0a.862.862,0,1,1-.862.862A.862.862,0,0,1,102.687,162.416Zm7.811,5.229a6.116,6.116,0,0,1-8.592,0,.862.862,0,1,1,1.144-1.289,4.4,4.4,0,0,0,6.3,0,.862.862,0,0,1,1.143,1.289Z",
    transform: "translate(-91.493 -150.188)",
    fill: "#387f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPopupIcon);
export default __webpack_public_path__ + "static/media/chatbot-popup-icon.10f481d122c4ec2686fc1da339a1266e.svg";
export { ForwardRef as ReactComponent };